import { observable, action } from 'mobx'
import ApiCaller from '../utils/api-caller'

class WeatherStore{
    @observable main = ''
    @observable description = ''
    @observable temp = ''
    @observable icon = ''
    @observable defaultLang = true
    @observable cityName = ''

    @action
    get(){
        let lang = window.localStorage.getItem("lang");
        if(!lang) lang = 'en'

        return ApiCaller.Weather.Get(lang).then((response) => {
            if (response) {
                if(response.weather.length > 0){
                    const weatherResult = response.weather[0]
                    this.main = weatherResult.main
                    this.description = weatherResult.description
                    this.icon = `http://openweathermap.org/img/wn/${weatherResult.icon}.png`
                }
    
                this.defaultLang = lang === 'en' ? true : false
                this.temp = response.main.temp
                this.cityName = response.name
            }
        })
    }
}

export default new WeatherStore();